@let filteredProducts = products | filterInfos: store.homeFilterText | groupProducts;

@if (filteredProducts) {
  @if (conf.conf.hasBP2) {
    <mat-chip-set>
      @for (chip of searchProductsService.selectedFilters | keyvalue; track chip.key) {
        <div>
          <mat-chip color="accent" highlighted removable (removed)="removeChip(chip.key)">
            {{ chip.value }}
            @if (chip.key !== "aircraftTechnicalName" && chip.key !== "occCode") {
              <mat-icon matChipRemove svgIcon="close"></mat-icon>
            }
          </mat-chip>
        </div>
      }
    </mat-chip-set>
  }
  @if (isRecentlyConsulted) {
    <div class="recently-consulted">
      <mat-icon svgIcon="history"></mat-icon>
      {{ "publist.recentlyConsulted" | translate }}
    </div>
  } @else {
    <div class="products-count">
      {{ "home.count.publications" | translate: { number: filteredProducts.length } }}
    </div>
  }
  @for (product of filteredProducts; track product.lastRev._id) {
    <o-card-pub-container [lastRev]="product.lastRev" [oldRevs]="product.oldRevs"> </o-card-pub-container>
  }
} @else {
  <o-loading [isLoading]="true"></o-loading>
}
